import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { CURRICULUM_SELECTION_CAMPAIGNS, StudentServicePath } from "utils/constants";
import permissions from "app/permissions";
import ListCurriculumSelectionCampaigns from "./List";
import CreateCurriculumSelectionCampaign from "./Create";
import EditCurriculumSelectionCampaign from "./Edit";
import ShowCurriculumSelectionCampaign from "./Show";

export const resources = {
  isMenu: true,
  icon: <SwapHorizIcon />,
  name: StudentServicePath + CURRICULUM_SELECTION_CAMPAIGNS,
  title: "Кампании за избор на учебен план",
  list: <ListCurriculumSelectionCampaigns />,
  create: <CreateCurriculumSelectionCampaign />,
  createPermission: permissions.canManageCurriculumSelectionCampaigns,
  edit: <EditCurriculumSelectionCampaign />,
  editPermission: permissions.canManageCurriculumSelectionCampaigns,
  show: <ShowCurriculumSelectionCampaign />,
  permission: permissions.canPreviewCurriculumSelectionCampaigns,
};
